import React, {useEffect} from 'react';
import {useSelector} from "react-redux";
import {AddIcon, CloseIcon} from "../../../assets/icons";
import TextProperties from "../../../Components/TextProperties";
import {HeadingText} from "../../../Components/StyledComponents";
import {addTextToCanvas} from "../../../utils/helpers";
import GlobalAssetsText from "./GlobalAssetsTextPanel";

const TextPanel = ({setToggleSubMenu}) => {
    const {canvas} = useSelector((state) => state.canvas);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    }, []);

    const closeTextPanel = () => {
        setToggleSubMenu(false)
    }
    return (
        <div className="text-panel-wrapper">
            <div className='text-header'>
                <span className="heading-text">Text</span>
                <span onClick={closeTextPanel} className='cross-icon'><CloseIcon/></span>
            </div>
            <div className='add-text-btn-wrapper'>
                <div className='add-text-btn' onClick={() => addTextToCanvas('Your text here', 30, 'heading_text', canvas, false, true)}>
                    <span style={{marginRight: '5px', marginBottom: '-5px'}}><AddIcon/></span>
                    <span>Add your text</span>
                </div>
            </div>
            <TextProperties/>
            <hr className="solid-divider"/>
            <HeadingText>Text graphics</HeadingText>
            <GlobalAssetsText />

        </div>
    );
};

export default TextPanel;
